var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreements-modals"},[_c('spinner',{attrs:{"large":"","main":"","active":_vm.saving,"label":_vm.$t('login.accountSetup.setting')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }